import React from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import AboutBg from '../../../../Images/background/bg_about.png';
import LogoFilms from '../../../../Images/logos/logo_films_nav.png';
import ImdbImg from '../../../../Images/modals/films/about/logo_imdb.png';
import JonPhoto from '../../../../Images/modals/films/about/jon-about.png';
import JonPhotoMob from '../../../../Images/modals/films/about/jon-about-mob.png';

import {
  TITLE_ABOUT,
  ABOUT_NAME,
  ABOUT_CHARGE,
  ABOUT_DESCRIPTION,
} from '../../../../utils/ES/Modals/About';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 0 65px;
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;

  h2 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(147, 206, 255, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.25rem;
  margin-top: 25px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-wrap: wrap;
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

const InfoContainerMobile = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 1.75rem;
  margin-top: 20%;
  display: none;

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
  }

  [class*='__TitleContainer'] {
    [class*='__Paragraph'] {
      line-height: 1;
      margin-bottom: 0;
    }
  }
`;

const TextContainer = styled.div`
  max-width: 733px;
  width: 100%;

  p {
    text-align: justify;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  p {
    text-align: right;
  }
`;

const ImgContainer = styled.div`
  padding: 10px;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 0;
  }
`;

const ImdbLogo = styled.img`
  display: block;
  width: 75px;
`;

const JonImg = styled.img`
  display: block;
  width: 600px;

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

const ModalAbout = () => {
  const { closeModal } = useModal();

  return (
    <>
      <Modal id="about" bgImg={AboutBg}>
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoFilms}
                alt="Kuter Films Reel"
                onClick={closeModal}
                aria-label="Close modal"
              />
            </LogoContent>
            <RichText dataText={TITLE_ABOUT} />
          </TitleContent>
          <InfoContainer>
            <TextContainer>
              <TitleContainer>
                <Title>
                  <RichText dataText={ABOUT_NAME} />
                  <RichText dataText={ABOUT_CHARGE} />
                </Title>
              </TitleContainer>
              <RichText dataText={ABOUT_DESCRIPTION} />
            </TextContainer>
            <ImgContainer>
              <a
                href="https://www.imdb.com/es-es/name/nm8573593/"
                rel="noopener"
                target="_blank"
              >
                <ImdbLogo src={ImdbImg} alt="iMDb" />
              </a>
            </ImgContainer>
            <ImgContainer>
              <JonImg src={JonPhoto} alt="Jonathan Bouzali" />
            </ImgContainer>
          </InfoContainer>

          <InfoContainerMobile>
            <TitleContainer>
              <Title>
                <RichText dataText={ABOUT_NAME} />
                <RichText dataText={ABOUT_CHARGE} />
              </Title>
            </TitleContainer>
            <ImgContainer>
              <a
                href="https://www.imdb.com/es-es/name/nm8573593/"
                rel="noopener"
                target="_blank"
              >
                <JonImg src={JonPhotoMob} alt="Jonathan Bouzali" />
              </a>
            </ImgContainer>
            <TextContainer>
              <RichText dataText={ABOUT_DESCRIPTION} />
            </TextContainer>
          </InfoContainerMobile>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalAbout;
